import { render, staticRenderFns } from "./MayoristasCRUD.vue?vue&type=template&id=68ee8814"
import script from "./MayoristasCRUD.vue?vue&type=script&lang=js"
export * from "./MayoristasCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports